// import HeroSlider from "../components/heroSlider";
// import LogoCarousel from "../components/logoCarousel";
import About from "../components/aboutCompInHome";
import ApronHighlight from "../components/apronHighlight";
import BlogSection from "../components/blogSection";
import CategoryStrip from "../components/categoryStrip";
import ColoringBooks from "../components/coloringBooks";
import ContactSection from "../components/contactSection";
import FeaturedProducts from "../components/featuredProductSection";
import HeroSlider from "../components/heroSlider";
import NavBar from "../components/navBarComp";
import PricingSection from "../components/pricingSectionComp";
import ContactUs1 from "../components/test";

function HomePage(){
    return(
        <>
            <NavBar/>
            <HeroSlider/>
            <CategoryStrip/>
            <About/>
            
            <FeaturedProducts/>
            <ApronHighlight/>
            <ColoringBooks/>
            <BlogSection/>
            <PricingSection/>
            {/* <ContactUs1/> */}
            <ContactSection/>
            {/* <HeroSlider/>
            <LogoCarousel/> */}
        </>
    )
}

export default HomePage;